import React, {Component} from 'react';
import {Helmet} from "react-helmet";

class Breadcrumbs_Schema_org extends Component {
    
    constructor(props, context) {
        super(props, context);
        
        this.createListBreadcrumbs = this.createListBreadcrumbs.bind(this);
        this.createJSONSchema = this.createJSONSchema.bind(this);
        
    }
    
    
    createListBreadcrumbs() {
        
        /* let array = [
        {
            "@type": "ListItem",
            "position": 1,
            "name": "Inicio",
            "item": "https://blog.adopta-un-animal.es/"
        }]
        }*/
        
        
        return this.props.listBreadcrumbs.map((breadcrumb, index) => {
            return {
                "@type": "ListItem",
                "name": breadcrumb.title,
                "position": index + 1,
                "item": this.props.HOST + breadcrumb.path
            }
        })
    }
    
    createJSONSchema() {
        const arrayBreadcrumbs = this.createListBreadcrumbs()
        
        arrayBreadcrumbs.push({
            "@type": "ListItem",
                "name": this.props.lastElement,
                "position": arrayBreadcrumbs.length + 1
        })
        
        
        return {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": arrayBreadcrumbs
        }
        
        
    }
    
    render() {
        return (
            <Helmet>
                <script id="breadcrumb_jsonld" type="application/ld+json" data-testid="json-ld-script">
                    {JSON.stringify(this.createJSONSchema())}
                </script>
            </Helmet>
        );
    }
    
    componentWillMount() {
    
    }
    
    componentDidMount() {
    
    
    }
    
    componentDidUpdate() {
    
    }
    
    
}

export default Breadcrumbs_Schema_org
